export default "__VITE_ASSET__BGMbBA_O__"